module.exports = __webpack_public_path__ + "img/PLC-Logo.0de88989.svg";